import { useCallback, useEffect, useState } from 'react';

import {
  type CourierMondayStatus,
  fetchMondayStatus,
} from 'features/courier-portal/services/courierPortalService';

export interface UseRecruitmentStatus {
  status: CourierMondayStatus | null;
  loading: boolean;
  errored: boolean;
  refresh: () => Promise<void>;
}

export const useRecruitmentStatus = (): UseRecruitmentStatus => {
  const [status, setStatus] = useState<CourierMondayStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const [errored, setErrored] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    setErrored(false);
    try {
      const data = await fetchMondayStatus();
      setStatus(data);
    } catch {
      setErrored(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { status, loading, errored, refresh };
};
